import {
  ODataHeader,
  ODataString,
  ODataDecimal,
  ODataInteger,
  ODataEnum,
  ODataBoolean,
} from "pbas-vue-components";


import { translate2 } from "../trans2";

export default [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "PlanId",
    type: new ODataString("PlanId"),
    sortable: false,
    visible: false,
    searchable: false,
    isIdentifier: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Translations[]/Name", {
      getString: (item) => translate2(item, "Name"),
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.description",
    type: new ODataString("Translations[]/Description", {
      getString: (item) => translate2(item, "Description"),
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    title: "globals.phone",
    type: new ODataString("Phone"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.address",
    type: new ODataString("Address"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.active",
    type: new ODataBoolean("IsActive"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.logo",
    type: new ODataString("Translations[]/Image/PhysicalFile/Path", {
      getHtml: function(item) {
        //console.log(item, translate2(item, 'Image'))
        return `<img src='${
            translate2(item, 'Image').PhysicalFile.Path
        }' style='max-height: 120px'/>`;
      },
    }),
    sortable: false,
    visible: true,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/Image/PhysicalFile/Id"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.order",
    type: new ODataInteger("Order"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  
];
